<template>
    <article class="blogpost-preview-item" @click="handleClick">
        <div class="blogpost-preview-item__content">
            <div>
                <!-- 标题 -->
                <h2 class="blogpost-preview-item__title">{{data.title}}</h2>
                <!-- 描述 -->
                <p class="blogpost-preview-item__description">{{data.description}}</p>
                <!-- 标签 -->
                <div class="blogpost-preview-item__tag-list">
                    <template v-for="tag in tagList">
                        <blogpost-tag :key="tag.id">{{tag.description}}</blogpost-tag>
                    </template>
                </div>
            </div>
            <!-- 信息 -->
            <div class="blogpost-preview-item__info">
                <span class="blogpost-preview-item__author">{{author.name}}</span>
                <span class="blogpost-preview-item__break">•</span>
                <span class="blogpost-preview-item__date">{{publishDate}}</span>
                <span class="blogpost-preview-item__break">•</span>
                <span class="blogpost-preview-item__read">{{views}} 次阅读</span>
            </div>
        </div>
        <div class="blogpost-preview-item__thumb">
            <app-image :src="thumbUrl" ratio="16:9"/>
        </div>
    </article>
</template>

<script>
    import BlogpostTag from '@components/BlogpostTag'
    import AppImage from '@components/AppImage'

    import {formatDate} from '@utils'
    import {DEFAULT_THUMB_URL} from '@config'

    export default {
        name: "BlogpostPreviewItem",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            tagList() {
                const {data} = this
                return data.tags || []
            },
            author() {
                const {data} = this
                return data.author || {}
            },
            // 发布日期
            publishDate() {
                const {data} = this
                const {publishDate} = data || {}
                if (publishDate) {
                    return formatDate(new Date(publishDate), 'yyyy年MM月dd日')
                }
                return '无'
            },
            thumbUrl() {
                const {data} = this
                const {thumbUrl} = data || {}
                return thumbUrl || DEFAULT_THUMB_URL
            },
            views() {
                const {data} = this
                const {views} = data || {}
                return views || 0
            }
        },
        methods: {
            handleClick() {
                const {data} = this
                const {id} = data
                this.$router.push({
                    name: 'blog',
                    params: {
                        id
                    }
                })
            }
        },
        components: {
            BlogpostTag,
            AppImage
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";
    @import "@assets/styles/mixins.scss";

    .blogpost-preview-item {
        display: flex;
        flex-direction: column-reverse;
        position: relative;
        padding: $paddingMD;
        margin-bottom: $paddingSP;
        border-radius: $radius;
        background-color: $componentBackgroundColor;
        background-color: var(--componentBackgroundColor);
        cursor: pointer;
        @include transition-colors;

        &:hover {
            background-color: $componentHighLightColor;
            background-color: var(--componentHighLightColor);
        }

        &__content {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            padding-right: $paddingMD;
            overflow: hidden;
        }

        &__thumb {
            width: 100%;
            margin-bottom: $paddingMD;
            overflow: hidden;
        }

        &__title {
            color: $textColor;
            color: var(--textColor);
            font-size: $fontSizeMD;
            font-weight: $fontWeightBold;
            margin-bottom: $paddingMD;
            @include transition-colors;

            &:hover {
                color: $primaryColor;
                color: var(--primaryColor);
            }
        }

        &__description {
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
            font-size: $fontSize;
            margin-bottom: $paddingMD;
        }

        &__tag-list {
            margin-bottom: $paddingBase;
        }

        &__info {
            font-size: $fontSizeCommon;
            color: $secondaryTextColor;
            color: var(--secondaryTextColor);
        }

        &__break {
            margin: 0 $paddingBase;
        }

        &__author {
            font-weight: $fontWeightBold;
            color: $textColor;
            color: var(--textColor);
        }
    }


    @media (min-width: 1024px) {
        .blogpost-preview-item {
            flex-direction: row;

            &__content {
                width: 66.6667%;
                padding-right: 0;
            }

            &__thumb {
                width: 33.3333%;
                margin-bottom: 0;
            }
        }
    }
</style>